<template>
  <v-hover v-slot="{ hover }">
    <v-card
      width="100%"
      height="100%"
      :elevation="hover ? 4 : 1"
      @click="onCardClick"
    >
      <v-img :aspect-ratio="1.618 / 1" :src="imgSrc">
        <v-card
          class="pa-3"
          tile
          flat
          color="rgba(	117, 117, 117, 0.8)"
          width="100%"
          style="position: absolute; bottom: 0px; left: 0px"
        >
          <h2
            v-if="lg"
            class="text-center text-truncate white--text font-weight-medium"
          >
            {{ text }}
          </h2>
          <h3
            v-else
            class="text-center text-truncate white--text font-weight-medium"
          >
            {{ text }}
          </h3>
        </v-card>
      </v-img>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'ImageCard',
  props: {
    imgSrc: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    lg: Boolean,
  },
  emits: ['click'],
  methods: {
    onCardClick() {
      this.$emit('click');
    },
  },
};
</script>
